module.exports = {
    namespace:'modal',
    backdrop:"modal-backdrop fade in",
    dialog:"modal-dialog",
    content:"modal-content",
    close:'close',
    body:'modal-body clearfix',
    header:'modal-header',
    footer:"modal-footer",
    overlay:''
}


/** WEBPACK FOOTER **
 ** ./src/styles/ModalTemplate-style.js
 **/